import {Injectable} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {config} from '../../shared/config';
import { first, map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { ReportHistoryMetadata } from '../models/report-history-metadata';
import { DataHelper } from '../../shared/helpers/data.helper';
import { StorageService } from '../../core/storage/storage.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  private progressSubject: Subject<number> = new Subject<number>();

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
  }

  schedule(params) {
    return this._http.post(config.generateApiUrl('report', null, null, '2.0'), params, { observe: 'response' }).pipe(
      map((response) => {
        return response; // HttpResponse
      })
    );
  }

  requestReportFile(reportFileId: number) {
    this._http.get(config.generateApiUrl('reportfiles/' + reportFileId + '/downloadLink', null, null,'2.2'), {responseType: 'json'})
      .pipe(first())
      .subscribe((res) => {
        if (res) {
          this.downloadFile(res['data']['item']);
        }
      });
  }

  getProgressObservable() {
    return this.progressSubject.asObservable();
  }

  getRequestReportFileTypes(reportGeneratorId: string) {
    return this._http.get(config.generateApiUrl('report/fileTypes/' + reportGeneratorId, null, null, '2.0'))
      .pipe(
        map( res => ({ id: reportGeneratorId, fileTypes: res['data'] as number[]}))
      );
  }

  getReportsHistory(params: {createdAfter?: string, createdBefore?: string}): Observable<ReportHistoryMetadata[]> {
    let queryParams = '';
    for (const key in params) {
      if (DataHelper.hasValue(params[key])) {
        queryParams += queryParams.indexOf('?') > -1 ? '&' : '?';
        queryParams += `${key}=${params[key]}`
      }
    }
    return this._http.get(config.generateApiUrl(`ReportFiles${queryParams}`, ['*'], null))
      .pipe(
        map( res => res['data']['items'] as ReportHistoryMetadata[])
      );
  }

  getReportMetadata(reportFileId: number) {
    const fields = ['*'];
    return this._http.get(config.generateApiUrl('ReportFiles/' + reportFileId + '/metadata', fields, null, '1.8')).pipe(
        map( res => res['data']['item'] as any)
    );
  }

  async downloadFile(fileDetails) {
  let progress = 0;
  this._http.get(fileDetails.reportDownloadLink, { responseType: 'blob', reportProgress: true, observe: 'events' })
  .subscribe(event => {
    if (event.type === HttpEventType.DownloadProgress) {
      progress = Math.round((100 * event.loaded) / event.total);
      this.updateProgress(progress);  
    } else if (event.type === HttpEventType.Response) {
      const blob: Blob = event.body as Blob;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileDetails.fileName;
      link.click();
      window.URL.revokeObjectURL(url);
      this.updateProgress(100);  
    }
  });
  }

  updateProgress(progress: number) {
    this.progressSubject.next(progress);
  }

  validDate(dateFrom, dateTo): boolean {
    let result = false;
    const timestampFrom = new Date(dateFrom).getTime();
    const timestampTo = new Date(dateTo).getTime();

    if (timestampFrom <= timestampTo) {
      result = true;
    }
    return result;
  }
}
